export enum subscriptionProductIds {
  preferredCustomer = '784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e',
  wineClub = 'e59cd67d-084f-48c4-b51f-3d20750e793f',
}

// Names of the preferred customer membership enums only (in case we add more subscriptions that are different).
export const enumNamesPreferredCustomer = ['preferredCustomer'];

// Names of the wineclub membership enums only
export const enumNamesWineClub = ['wineClub'];

// Ids of all subscription products as a list
export const subscriptionProductIdsList = Object.values(subscriptionProductIds);

/**
 *
 * Generic Subscription Functions
 *
 */
export const containsSubscriptionProductId = (productIds: string[]) =>
  !!productIds.find(id => subscriptionProductIdsList.includes(id));

// Get all subscriptions found in productIds list, and return their enum names.
export const getAllSubscriptionEnumsInList = (productIds: string[]): string[] =>
  Object.keys(subscriptionProductIds).filter(
    (enumName: keyof typeof subscriptionProductIds) =>
      productIds.find(id => id.toString() === subscriptionProductIds[enumName]),
  );

// Get all subscriptions found in productIds list, and return only those product Ids.
export const getAllSubscriptionProductIdsInList = (
  productIds: string[],
): string[] =>
  Object.values(subscriptionProductIds).filter((productId: string) =>
    productIds.find(id => id.toString() === productId),
  );

/**
 *
 * Preferred Customer specific functions
 *
 */
export const containsPreferredCustomerProductId = (productIds: string[]) =>
  !!productIds.find(id => id === subscriptionProductIds.preferredCustomer);

// Get all preferred customer products in the productIds, and return their corresponding enum names.
export const getAllPreferredCustomerEnumsInList = (
  productIds: string[],
): string[] =>
  enumNamesPreferredCustomer.filter(
    (enumName: keyof typeof subscriptionProductIds) =>
      productIds.find(id => id.toString() === subscriptionProductIds[enumName]),
  );

// Not sure if wine club belongs in "preferred customer specific functions" or "wine club specific functions"...
export const containsWineClubProductId = (productIds: string[]) =>
  !!productIds.find(id => id === subscriptionProductIds.wineClub);
